import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 700px;
  margin: 1rem 0;

  p {
    margin: 0;
  }
`;
